import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from '../base/grid';
import { A, H4, P } from '../base/typography';
import * as StyledSuccessOrFailure from './successOrFailure.styles';
import {StyledErrorMessage} from '../base/forms/formikFieldWrapper.styles';

interface Props {
	hasSubmitted: boolean;
	success: boolean;
	addLink?: boolean;
	downloadFileFunction?: any;
	translationFile?: string;
	messageArray?: string[];
	errorMessage?: string;
}

const SuccessOrFailure: FC<Props> = ({
	hasSubmitted,
	success,
	addLink,
	downloadFileFunction,
	messageArray,
	translationFile = 'generalForm',
	errorMessage,
}) => {
	const { t } = useTranslation(translationFile);
	if (!hasSubmitted) return null;
	return (
		<StyledSuccessOrFailure.Wrapper>
			{!success && (
				<Column>
					<P marginBottom="2rem">{`${t('thereWasAnError')}`}</P>
					{errorMessage && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
					{!errorMessage && <StyledErrorMessage>{`${t('thereWasAnErrorText')}`}</StyledErrorMessage>}
				</Column>
			)}

			{success && (
				<Column paddingLeft="0">
					<H4 marginBottom="3rem">{`${t('success')}`}</H4>
					{messageArray && messageArray.map((item, index) => <P key={index}>{item}</P>)}
					{addLink && (
						<>
							<P marginTop="1rem">{`${t('open-pdf')}`}</P>
							<P>{`${t('print-pdf')}`}</P>
							<A onClick={downloadFileFunction}>{`${t('open-pdf-link')}`}</A>
						</>
					)}
				</Column>
			)}
		</StyledSuccessOrFailure.Wrapper>
	);
};

export default SuccessOrFailure;
